import {useQuery} from 'react-query'
import {useParams} from 'react-router-dom'
import usePaginationCounts from '../../utils/hooks/usePaginationCounts'
import axios from 'axios'
import {BASE_URL} from '../config'
import {useEffect, useState} from 'react'
import {IRouteSenderDetails, IRouteSenderRoles} from './_model'
import {searchItems} from '../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../utils/contextProvider/ListViewProvider'
import TableContent from '../../utils/components/table-content/TableContent'
import TablePagination from '../../utils/components/table-content/TablePagination'
import {KTIcon} from '../../../_metronic/helpers'
import RolesDetailsHeader from './RoleDetailsHeader'
import routeSenderDetailsColumn from './routeSenderDetailsColumn'
import AddSender from './modal/AddSender'
import UpdateRouteRoleStatus from './modal/UpdateRouteRoleStatus'
import {ISenderIdArray} from '../SMSBroadCast/core/_model'
import {ISenderIdsOption} from '../../hooks/useSenderIdsOptions'
import {ISelectOption} from '../../utils/core/_model'

const GET_ROUTE_SENDER_ROLES_BY_ID_URL = `${BASE_URL}/api/protect/getRouteSenderRoles`
const GET_ROUTE_SENDER_DETAILS_BY_ROLES = `${BASE_URL}/api/protect/getRouteSenderDetailsByRules`
const GET_SENDER_BY_ID = `${BASE_URL}/api/protect/getSendersByRoute`

const RouteSenderDetails = () => {
  const {roleName, id} = useParams()
  const {
    pagination: {page, size, totalElement},
    updatePagination,
    handlePageChange,
    handlePagePerItem,
  } = usePaginationCounts(1, 10)

  const [searchTerm, setSearchTerm] = useState('')
  const [rolesDetails, setRolesDetails] = useState<IRouteSenderDetails[]>([])
  const [roles, setRoles] = useState<IRouteSenderRoles | null>(null)
  const [updateStatus, setUpdateStatus] = useState<IRouteSenderDetails | null>(null)

  const {data, isLoading, error} = useQuery({
    queryKey: ['createRouteSenderRoles', {page, size, roleName}],
    queryFn: async () => {
      const [getByIdRes, routeDetailsRes] = await Promise.all([
        axios.get(`${GET_ROUTE_SENDER_ROLES_BY_ID_URL}/${id}`),
        axios.get(`${GET_ROUTE_SENDER_DETAILS_BY_ROLES}/${id}`, {
          params: {page, size},
        }),
      ])
      // const getByIdRes = await axios.get(`${GET_ROUTE_SENDER_ROLES_BY_ID_URL}/${id}`)
      // const routeDetailsRes = await axios.get(`${GET_ROUTE_SENDER_DETAILS_BY_ROLES}/${id}`, {
      //   params: {page, size},
      // })

      const data = await routeDetailsRes.data
      const getByIdData = await getByIdRes.data

      console.log(getByIdRes.status)
      console.log(getByIdRes)

      if (getByIdRes.status === 200) {
        const {sourceId, destinationId} = getByIdData

        const [sourceSendersRes, destinationSendersRes] = await Promise.all([
          axios.get(`${GET_SENDER_BY_ID}/${sourceId}`),
          axios.get(`${GET_SENDER_BY_ID}/${destinationId}`),
        ])

        const sourceSenders = sourceSendersRes.data
        const destinationSenders = destinationSendersRes.data

        // console.log(sourceSenders, destinationSenders)

        return {
          list: data.data,
          pagination: data.pagenationResponse,
          roles: getByIdData,
          source_senders: arrangedSenders(sourceSenders),
          destination_senders: arrangedSenders(destinationSenders),
        }
      }

      return {
        list: data.data,
        pagination: data.pagenationResponse,
        roles: getByIdData,
        source_senders: [],
        destination_senders: [],
      }
    },
    enabled: !!roleName && !!id,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: 0,
    cacheTime: 0,
  })

  const arrangedSenders = (senders: ISenderIdArray) => {
    const arrangedOptions: ISelectOption[] = senders.map((id: any) => {
      return {
        id: id.id,
        value: id.sender,
        label: id.sender,
      }
    })

    return arrangedOptions
  }

  const handleSelect = async (id: number) => {
    const selected = rolesDetails.find((role) => role.altId === id)

    if (selected) {
      setUpdateStatus(selected)
    }
  }

  useEffect(() => {
    if (data) {
      const keys: (keyof IRouteSenderDetails)[] = [
        'destinationSender',
        'sourceSender',
        'lastUpdate',
      ]
      const filtered = searchItems(data.list, searchTerm, keys)
      setRolesDetails(filtered)
      setRoles(data.roles)
      updatePagination(data.pagination)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchTerm])

  return (
    <div>
      <ListViewProvider data={rolesDetails} isLoading={isLoading}>
        {isLoading || !data ? (
          <></>
        ) : (
          <div className='card mb-5'>
            <div className='card-body d-flex gap-10 justify-content-between flex-wrap'>
              <div>
                <h4>Name</h4>
                <p className='text-gray-800 fs-4 mb-0'>{roles?.name}</p>
              </div>

              <div>
                <h4>Type</h4>
                <p className='text-gray-800 fs-4 mb-0'>
                  {roles?.type === '1' ? 'Route' : 'Sender'}
                </p>
              </div>

              <div>
                <h4>Source Name</h4>
                <p className='text-gray-800 fs-4 mb-0'>{roles?.sourceName}</p>
              </div>

              {/* <div>
                <h4>Source</h4>
                <p className='text-gray-800 fs-6 mb-0'>{roles?.source}</p>
              </div> */}

              <div>
                <h4>Destination Name</h4>
                <p className='text-gray-800 fs-4 mb-0'>{roles?.destinationName}</p>
              </div>

              {/* <div>
                <h4>Destination</h4>
                <p className='text-gray-800 fs-6 mb-0'>{roles?.destination}</p>
              </div> */}

              <div>
                <h4>Status</h4>

                <span
                  className={`badge fs-6 ${
                    roles?.status === '1' ? 'badge-light-primary' : 'badge-light-danger'
                  }`}
                >
                  {roles?.status === '1' ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex gap-5 align-items-center'>
            <div className='d-flex align-items-center position-relative my-1 w-500px'>
              <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
              <input
                type='text'
                className='form-control form-control-solid ps-16 rounded-pill py-3 bg-transparent border border-gray-700'
                placeholder='Search by source name, destination name, sender'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className='d-flex align-items-center'>
            <RolesDetailsHeader size={size} handlePagePerItem={handlePagePerItem} />
            <button className='btn btn-primary' data-bs-toggle='modal' data-bs-target='#kt_modal_1'>
              <KTIcon iconName='plus' className='fs-3' />
              Add Sender
            </button>
          </div>
        </div>

        <TableContent
          isLoading={isLoading}
          error={error as Error}
          tableData={rolesDetails}
          tableColumn={routeSenderDetailsColumn(handleSelect)}
        >
          {isLoading && !data ? (
            <div className='d-flex justify-content-center'>
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <TablePagination
              totalElement={totalElement}
              isLoading={isLoading}
              itemsPerPage={size}
              currentPage={page}
              handlePageChange={handlePageChange}
            />
          )}
        </TableContent>
      </ListViewProvider>

      <AddSender
        rolesid={id}
        routeSenderRolesDetails={roles}
        source_senders={data?.source_senders}
        destination_senders={data?.destination_senders}
      />
      <UpdateRouteRoleStatus selctedRole={updateStatus} />
    </div>
  )
}

export default RouteSenderDetails
